export default __webpack_public_path__ + "assets/hill3.png";